'use client';

import React from 'react';

import { Typography } from 'lighthouse';

import { CategoryChipsProps } from './models';

const CategoryChips = ({ items, activeId, onSelect }: CategoryChipsProps) => {
    if (!items.length) {
        return null;
    }

    return (
        <div className='nice-scroll -mx-4 flex gap-2 overflow-x-auto px-4 pb-1 md:mx-0 md:flex-wrap md:overflow-visible md:px-0'>
            {items.map((item) => {
                const isActive = activeId === item.id;

                return (
                    <button
                        type='button'
                        key={item.id}
                        aria-pressed={isActive}
                        onClick={() => onSelect(item.id)}
                        className={`shrink-0 cursor-pointer rounded-full border border-solid px-3.5 py-1.5 transition-all duration-200 ${
                            isActive
                                ? 'border-primary bg-primary text-white shadow-sm'
                                : 'border-N200 bg-white text-blackMediumEmphasis hover:border-primary/30 hover:bg-primary/5 hover:text-primary'
                        }`}>
                        <Typography
                            variant='caption'
                            component='span'
                            fontWeight={isActive ? 700 : 500}
                            className={`whitespace-nowrap leading-4 ${isActive ? 'text-white' : ''}`}>
                            {item.label}
                        </Typography>
                    </button>
                );
            })}
        </div>
    );
};

export default CategoryChips;
